/**
 * – Premium and expense statistics
 */

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 200 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 3 }
		},
		{
			s: { r: 1, c: 4 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 7 }
		},
		{
			s: { r: 1, c: 8 },
			e: { r: 1, c: 9 }
		},
		{
			s: { r: 1, c: 10 },
			e: { r: 1, c: 11 }
		},
		{
			s: { r: 1, c: 12 },
			e: { r: 1, c: 13 }
		},
		{
			s: { r: 1, c: 14 },
			e: { r: 2, c: 14 }
		},
		{
			s: { r: 1, c: 15 },
			e: { r: 2, c: 15 }
		},
		{
			s: { r: 1, c: 16 },
			e: { r: 2, c: 16 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	["Template 13 - Premium and expense statistics"],
	[
		"Type of plans",
		"Premium",
		"",
		"",
		"Commissions Payable",
		"",
		"Claims Paid",
		"",
		"Outstanding Claim b/f (including IBNR)",
		"",
		"Outstanding Claim c/f (including IBNR)",
		"",
		"Claims Incurred",
		"",
		"Unexpired Risks Adjustment (Claims Reserve) (HK$)",
		"Management Expenses (HK$)",
		"Underwriting Profit/Loss (HK$)"
	],
	[
		"",
		"Gross (HK$)",
		"Net (HK$)",
		"Net Earned (HK$)",
		"Gross (HK$)",
		"Net (HK$)",
		"No. of Claims",
		"(A) Gross amt (HK$)",
		"No. of Claims",
		"(B) Gross amt (HK$)",
		"No. of Claims",
		"(C) Gross amt (HK$)",
		"(A)-(B)+(C) Gross amt (HK$)",
		"Net"
	]
]

const rows = payload => [
	["Standard Plan", "", "", "", "", "", "", "", "", "", "", "", "", ""],
	["Flexi Plan", "", "", "", "", "", "", "", "", "", "", "", "", ""]
]
